/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  Pagination,
  TaxCreationParams,
  TaxListParams
} from '~core/models/core.models';
import { Tax } from '~core/models/core.models';
import { ApiConstantsService } from '~core/services/api-constants.service';

@Injectable()
export class TaxService {
  private _httpClient = inject(HttpClient);
  private _apiConstantsService = inject(ApiConstantsService);

  read(id: string): Observable<Tax> {
    return this._httpClient.get<Tax>(
      `${this._apiConstantsService.taxesUrl}/${id}`
    );
  }

  list(params?: TaxListParams): Observable<Pagination<Tax>> {
    return this._httpClient.get<Pagination<Tax>>(
      this._apiConstantsService.taxesUrl,
      {
        params: {
          ...params,
          sort: params?.sort || 'createdAt',
          desc: params?.desc || 'createdAt'
        } as Record<string, any>
      }
    );
  }

  create(data: TaxCreationParams): Observable<Tax> {
    return this._httpClient.post<Tax>(this._apiConstantsService.taxesUrl, {
      ...data,
      useStateFormViolationHandler: true
    });
  }

  update(id: string, data: Omit<Partial<Tax>, 'id'>): Observable<Tax> {
    return this._httpClient.patch<Tax>(
      `${this._apiConstantsService.taxesUrl}/${id}`,
      {
        ...data,
        useStateFormViolationHandler: true
      }
    );
  }

  delete(taxId: string): Observable<unknown> {
    return this._httpClient.delete<unknown>(
      `${this._apiConstantsService.taxesUrl}/${taxId}`
    );
  }
}
